/* eslint-disable */
/**
 * 按照给定的格式，对日期进行格式化
 * @param {Date|Number|String} date 日期
 * @param {String} format 格式
 * @returns {String} 格式化之后的日期
 */
export var format = (function () {
    var rword = /[^, ]+/g; //切割字符串为一个个小块，以空格或豆号分开它们，结合replace实现字符串的forEach
    var oproto = Object.prototype;
    var serialize = oproto.toString;
    var class2type = {};
    "Boolean Number String Function Array Date RegExp Object Error".replace(rword, function (name) {
        class2type["[object " + name + "]"] = name.toLowerCase()
    });

    /**
     * 转出数字
     * @param {String} str 字符串
     */
    function toInt(str) {
        return parseInt(str, 10)
    }

    function padNumber(num, digits, trim) {
        var neg = ""
        if (num < 0) {
            neg = '-';
            num = -num;
        }

        num = "" + num;
        while (num.length < digits)
            num = "0" + num;
        if (trim)
            num = num.substr(num.length - digits)
        return neg + num;
    }

    function dateGetter(name, size, offset, trim) {
        return function (date) {
            var value = date["get" + name]()
            if (offset > 0 || value > -offset)
                value += offset;
            if (value === 0 && offset === -12) {
                value = 12;
            }
            return padNumber(value, size, trim)
        }
    }

    function dateStrGetter(name, shortForm) {
        return function (date, formats) {
            var value = date["get" + name]()
            var get = (shortForm ? ("SHORT" + name) : name).toUpperCase()
            return formats[get][value]
        }
    }

    function timeZoneGetter(date) {
        var zone = -1 * date.getTimezoneOffset()
        var paddedZone = (zone >= 0) ? "+" : ""
        paddedZone += padNumber(Math[zone > 0 ? "floor" : "ceil"](zone / 60), 2) + padNumber(Math.abs(zone % 60), 2)
        return paddedZone
    }

    function ampmGetter(date, formats) {
        return date.getHours() < 12 ? formats.AMPMS[0] : formats.AMPMS[1]
    }
    var rfixYMD = /^(\d+)\D(\d+)\D(\d+)/
    var DATE_FORMATS = {
        yyyy: dateGetter("FullYear", 4),
        yy: dateGetter("FullYear", 2, 0, true),
        y: dateGetter("FullYear", 1),
        MMMM: dateStrGetter("Month"),
        MMM: dateStrGetter("Month", true),
        MM: dateGetter("Month", 2, 1),
        M: dateGetter("Month", 1, 1),
        dd: dateGetter("Date", 2),
        d: dateGetter("Date", 1),
        HH: dateGetter("Hours", 2),
        H: dateGetter("Hours", 1),
        hh: dateGetter("Hours", 2, -12),
        h: dateGetter("Hours", 1, -12),
        mm: dateGetter("Minutes", 2),
        m: dateGetter("Minutes", 1),
        ss: dateGetter("Seconds", 2),
        s: dateGetter("Seconds", 1),
        sss: dateGetter("Milliseconds", 3),
        EEEE: dateStrGetter("Day"),
        EEE: dateStrGetter("Day", true),
        a: ampmGetter,
        Z: timeZoneGetter
    }

    var DATE_FORMATS_SPLIT = /((?:[^yMdHhmsaZE']+)|(?:'(?:[^']|'')*')|(?:E+|y+|M+|d+|H+|h+|m+|s+|a|Z))(.*)/,

        NUMBER_STRING = /^\d+$/;

    var riso8601 = /^(\d{4})-?(\d+)-?(\d+)(?:T(\d+)(?::?(\d+)(?::?(\d+)(?:\.(\d+))?)?)?(Z|([+-])(\d+):?(\d+))?)?$/;

    var locate = {
        AMPMS: {
            0: "上午",
            1: "下午"
        },

        DAY: {
            0: "星期日",
            1: "星期一",
            2: "星期二",
            3: "星期三",
            4: "星期四",
            5: "星期五",
            6: "星期六"
        },

        MONTH: {
            0: "1月",
            1: "2月",
            2: "3月",
            3: "4月",
            4: "5月",
            5: "6月",
            6: "7月",
            7: "8月",
            8: "9月",
            9: "10月",
            10: "11月",
            11: "12月"
        },

        SHORTDAY: {
            "0": "周日",
            "1": "周一",
            "2": "周二",
            "3": "周三",
            "4": "周四",
            "5": "周五",
            "6": "周六"
        },

        fullDate: "y年M月d日EEEE",
        longDate: "y年M月d日",
        medium: "yyyy-M-d H:mm:ss",
        mediumDate: "yyyy-M-d",
        mediumTime: "H:mm:ss",
        "short": "yy-M-d ah:mm",
        shortDate: "yy-M-d",
        shortTime: "ah:mm"
    }

    locate.SHORTMONTH = locate.MONTH

    function checkType(obj) { //取得目标的类型

        if (obj == null) {
            return String(obj)
        }

        // 早期的webkit内核浏览器实现了已废弃的ecma262v4标准，可以将正则字面量当作函数使用，因此typeof在判定正则时会返回function

        return typeof obj === "object" || typeof obj === "function" ?
            class2type[serialize.call(obj)] || "object" :
            typeof obj

    }

    function jsonStringToDate(string) {
        string = string.replace(/\s/g, "T")
        var match
        if (match = string.match(riso8601)) {
            var date = new Date(0),
                tzHour = 0,
                tzMin = 0,
                dateSetter = match[8] ? date.setUTCFullYear : date.setFullYear,
                timeSetter = match[8] ? date.setUTCHours : date.setHours

            if (match[9]) {
                tzHour = toInt(match[9] + match[10])
                tzMin = toInt(match[9] + match[11])
            }

            dateSetter.call(date, toInt(match[1]), toInt(match[2]) - 1, toInt(match[3]))
            var h = toInt(match[4] || 0) - tzHour
            var m = toInt(match[5] || 0) - tzMin
            var s = toInt(match[6] || 0)
            var ms = Math.round(parseFloat('0.' + (match[7] || 0)) * 1000)
            timeSetter.call(date, h, m, s, ms)
            return date
        }

        return string
    }

    return function (date, format) {
        if (date === '') { //为空字符串的处理
            return '';
        }

        var text = "",
            parts = [],
            fn, match;

        format = format || "mediumDate"
        format = locate[format] || format
        if (typeof date === "string") {
            if (NUMBER_STRING.test(date)) {
                date = toInt(date)
            } else {
                var trimDate = date.trim()
                date = trimDate.replace(rfixYMD, function (a, b, c, d) {
                    var array = d.length === 4 ? [d, b, c] : [b, c, d]
                    return array.join("-")
                })

                date = jsonStringToDate(date)
            }

            date = new Date(date)
        }

        if (typeof date === "number") {
            date = new Date(date)
        }

        if (checkType(date) !== "date") {
            return '';
        } else if(date.getTime && !date.getTime()){
            return '';
        }

        while (format) {
            match = DATE_FORMATS_SPLIT.exec(format)
            if (match) {
                parts = parts.concat(match.slice(1))
                format = parts.pop()
            } else {
                parts.push(format)
                format = null
            }

        }

        parts.forEach(function (value) {
            fn = DATE_FORMATS[value]
            text += fn ? fn(date, locate) : value.replace(/(^'|'$)/g, "").replace(/''/g, "'")
        });
        return text == "undefined" ? "" : text;

    }
}());


export var getMonthDays = (function(){
    const config = {
        fmt:'yyyy-MM-dd',
        weekType:0,//0从星期一到星期日，1从星期日到星期六
        weekPrefix:'星期',   //星期一, 周一        
    }

    // 日历组件相关
    const WEEK = ['日','一','二','三','四','五','六'],
          COUNT = 42; //7*6天的日历框

    function getMonthDays(date,opt={}){
        let _date = typeof date === 'string' ? new Date(formateDateString(date)) : new Date(date),
            boxDays = []; 
        opt = Object.assign({},config,opt);        
        _date.setDate(1); //置为第一天
        let weekday = _date.getDay(), //第一天是星期几
            _month = _date.getMonth()+1,
            reduce = opt.weekType != 0 ? 1- weekday   : 
                 weekday == 0 ? -5 :  2 -weekday;

        _date.setDate(reduce); //日历的第一天     
        for (let i = 0; i < COUNT;  i++ ){
            boxDays.push(getDateInfo(_date,_month,opt.fmt,opt.weekPrefix));
            _date.setDate(_date.getDate()+1);
        }
        return boxDays;
    }
    function getDateInfo(date,_month,fmt,prefix){ //返回日期信息
        let weekday = date.getDay(),
            datestr = format(date,fmt),
            weekname = prefix +  WEEK[weekday];

        return {
            weekname,
            weekday: weekday,
            year: date.getFullYear(),
            month: date.getMonth() + 1,
            day: date.getDate(),
            datestr: datestr,
            thisMonth: date.getMonth() + 1 == _month,
            isToday: format(date,'yyyy-MM-dd') == getServerTime('yyyy-MM-dd')
        }
    }

    function formateDateString(date){
        return date.replace('T',' ').replace(/-/g,'\/');
    }
    return getMonthDays;
}());


export function getMonthRange(date,fmt,type=0){
    let _date = new Date(date);
    _date.setDate(1); //置为第一天
    let weekday = _date.getDay(), //第一天是星期几
        reduce = type != 0 ? 1- weekday   : 
                 weekday == 0 ? -5 :  2 -weekday;

    _date.setDate(reduce); //日历的第一天   
    let start = fmt ? format(_date,fmt) : new Date(_date);
    _date.setDate(_date.getDate()+41);
    let end  = fmt ? format(_date,fmt) : new Date(_date);
    return [start,end];
}


export function getWeekRange(date,fmt,type=0){
    let _date = new Date(date),
        weekday = _date.getDay(),
        reduce = type == 0 ? (weekday == 0 ? 6 : weekday - 1) : weekday;
    _date.setDate(_date.getDate() - reduce); //日历的第一天   
    let start = fmt ? format(_date,fmt) : new Date(_date);
    _date.setDate(_date.getDate()+6);
    let end  = fmt ? format(_date,fmt) : new Date(_date);
    return [start,end];     
}

export function getWeekArr(date,fmt,type=0){
    let [start,end] = getWeekRange(date,null,type), 
        arr = [new Date(start)];

    for (let i = 1; i < 7; i++){
        start.setDate(start.getDate()+1);
        arr.push(new Date(start));
    }
    return fmt ? arr.map(item=>format(item,fmt)) : arr;
}

export function getWeekObjArr(date,fmt='yyyy-MM-dd',type=0){
    let [start,end] = getWeekRange(date,null,type), 
        arr = [new Date(start)];

    for (let i = 1; i < 7; i++){
        start.setDate(start.getDate()+1);
        arr.push(new Date(start));
    }
    return arr.map(item=>({
        weekday:item.getDay(),
        day:item.getDate(),
        month:item.getMonth()+1,
        year:item.getFullYear(),
        datestr:format(item,fmt),
        name1:format(item,'EEEE'),
        name2:format(item,'EEE'),
        isToday: format(getServerTime(),'yyyy-MM-dd') == format(item,'yyyy-MM-dd')
    }));
}



export function getYearRange(opt={}){
    const config = {
        before:-5,
        after:10,
        thisYear:getServerTime().getFullYear()
    };
    let years = [];
    opt = Object.assign({},config,opt);
    for (let i = opt.before; i <= opt.after; i++){
        years.push(opt.thisYear + i);
    }
    return years;
}


export function getDayDiff(diff = 0){
    const day = getServerTime();
    day.setTime(day.getTime() + diff * 1000 * 60 * 60 * 24);
    return day;
}

export function getWeekDiff(diff = 0, fmt ,type){
    const day = getServerTime();
    day.setHours(0);
    day.setMinutes(0);
    day.setSeconds(0);
    day.setTime(day.getTime() + diff * 1000 * 60 * 60 * 24 * 7);
    return getWeekRange(day, fmt, type)
}

export function getMonthDiff(diff = 0){
    const start = getServerTime();
    start.setMonth(start.getMonth() + diff);
    start.setDate(1);
    const end = new Date(start);
    end.setMonth(end.getMonth() + 1);
    end.setDate(0);
    return [start, end];
}

export function getQuarterDiff(diff = 0){
    const start = getServerTime();
    const monthStart = start.getMonth();
    const quarterStart = parseInt(monthStart / 3) * 3;
    start.setMonth(quarterStart + diff * 3);
    start.setDate(1);

    const end = new Date(start);
    end.setMonth(end.getMonth() + 3);
    end.setDate(0);
    return [start, end];
}

export function getMonthRangeDiff(diff = 0){
    const start = getServerTime();
    const end = new Date(start);
    end.setMonth(end.getMonth() + diff);
    return diff > 0 ? [start, end]:[end, start];
}


let serverTime = null,timeDiff = 0;
export function setServerTime(time){
    serverTime = new Date(time);
    timeDiff = serverTime.getTime() - Date.now();
}

export function getServerTime(fmt){
    let now = Date.now() + timeDiff;
    return fmt ? format(new Date(now),fmt) : new Date(now);
}